<template>
    <div>
        <div class="row justify-content-md-center">
            <div class="col-md-8">
                <b-card class="mt-2">
                    <div class="row" v-if="venderData.velocimetro">
                        <div class="col-md-12">
                            <h4
                                class="text-center text-muted font-weight-light mt-4 text-uppercase"
                            >
                                {{ vehiculoData.marca_name }}
                                {{ vehiculoData.linea_name }}
                                {{ vehiculoData.version_name }} -
                                {{ vehiculoData.modelo }} con
                                {{
                                    numberWithoutDots(vehiculoData.kilometraje)
                                }}
                                KM
                            </h4>
                            <velocimetroVector
                                :retoma="
                                    numberWithDots(
                                        typeof cotizacionData.vr_retoma_min !=
                                            'undefined'
                                            ? cotizacionData.vr_retoma_min
                                            : cotizacionData.vr_retoma
                                    )
                                "
                                :minimo="
                                    numberWithDots(cotizacionData.vr_minimo)
                                "
                                :sugerido="
                                    numberWithDots(cotizacionData.vr_sugerido)
                                "
                                :publicacion="
                                    numberWithDots(cotizacionData.vr_publicado)
                                "
                                class="m-4"
                            />
                            <b-button
                                :href="
                                    'https://api.whatsapp.com/send?phone=573188274142&text=' +
                                        encodeURIComponent(
                                            'Hola! Te escribo desde la página web de Redautos. Realicé una solicitud de cotización de mi carro ' +
                                                vehiculoData.marca_name +
                                                ' ' +
                                                vehiculoData.modelo +
                                                ' ' +
                                                vehiculoData.linea_name +
                                                ' ' +
                                                vehiculoData.version_name +
                                                ' ' +
                                                numberWithoutDots(
                                                    vehiculoData.kilometraje
                                                ) +
                                                ' KM, quiero saber más sobre el proceso de venta con ustedes!'
                                        )
                                "
                                block
                                class="mt-4 btn-whatsapp btn-success"
                                size="sm"
                                target="_blank"
                            >
                                <i class="fa fa-whatsapp"></i> Chatea con un
                                asesor
                            </b-button>
                        </div>
                    </div>
                    <div
                        class="row align-items-center justify-content-center"
                        v-else
                    >
                        <div class="col-md-6 text-center">
                            <img
                                src="/assets/images/svg/the_search.svg"
                                alt="image"
                                class="img-fluid"
                                style="width: 50%;"
                            />
                        </div>
                        <div class="col-md-6 text-center">
                            <h4 class="mb-0 font-weight-lighter">
                                Estamos comparando precios con el mercado. Muy
                                pronto te llegara un correo con el avalúo
                                comercial del vehículo.
                            </h4>
                            <b-button
                                :href="
                                    'https://api.whatsapp.com/send?phone=573188274142&text=' +
                                        encodeURIComponent(
                                            'Hola! Te escribo desde la página web de Redautos. Realicé una solicitud de cotización de mi carro ' +
                                                vehiculoData.marca_name +
                                                ' ' +
                                                vehiculoData.modelo +
                                                ' ' +
                                                vehiculoData.linea_name +
                                                ' ' +
                                                vehiculoData.version_name +
                                                ' ' +
                                                numberWithoutDots(
                                                    vehiculoData.kilometraje
                                                ) +
                                                ' KM, quiero saber más sobre el proceso de venta con ustedes!'
                                        )
                                "
                                block
                                class="mt-4 btn-whatsapp btn-success"
                                size="sm"
                                target="_blank"
                            >
                                <i class="fa fa-whatsapp"></i> Chatea con un
                                asesor
                            </b-button>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import velocimetroVector from "components/velocimetro/velocimetroVector";
import helper from "helpers/main-helper";
export default {
    components: {
        velocimetroVector
    },
    computed: {
        asistenteStepData() {
            return this.$store.state.vender.asistente_step;
        },
        venderData() {
            return this.$store.state.vender;
        },
        cotizacionData() {
            return this.$store.state.vender.cotizacion;
        },
        vehiculoData() {
            return this.$store.state.vender.selection_data;
        },
        procesoData() {
            return this.$store.state.proceso.proceso;
        }
    },
    methods: {
        numberWithDots(string) {
            return helper.numberWithDots(string);
        },
        numberWithoutDots(string) {
            return helper.numberWithoutDots(string);
        }
    }
};
</script>

<style lang="scss" scoped></style>
